import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '../../constants/colors';
import screenSizes from '../../constants/screenSizes';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  border-radius: ${({ type }) => (type === 'round' ? '20px' : '0')};
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  outline: none;
  border: none;
  width: fit-content;
  max-width: 100%;
  padding: ${({ size }) => (size === 'standard' ? '8px 16px' : '8px 24px')};
  transition: all 0.3s ease;
  margin: 0 auto; // Center the button on mobile

  & span {
    font-size: 14px;
    font-weight: 600;
  }

  ${({ variant }) => variantStyles(variant)};

  @media (min-width: ${screenSizes.medium.min}) {
    width: auto;
    max-width: 200px;
    height: 28px;
    padding: ${({ size }) => (size === 'standard' ? '10px 20px' : '10px 40px')};
    margin: 0; // Reset margin for desktop

    & span {
      font-size: 13px;
      font-weight: 800;
    }
  }
`;

const variantStyles = (variant) => {
  switch (variant) {
    case 'white':
      return whiteButtonStyles;
    case 'ghost':
      return ghostStyles;
    case 'dark':
      return darkStyles;
    default:
      return defaultStyles;
  }
};

const defaultStyles = css`
  background-color: ${colors.BLUE};
  color: #fff;

  &:hover {
    background-color: #fff;
    color: ${colors.BLUE};
    border: 1px solid ${colors.BLUE};
  }
`;

const darkStyles = css`
  background-color: ${colors.DARK_BLUE};
  color: #fff;

  &:hover {
    background-color: #fff;
    color: ${colors.DARK_BLUE};
    border: 1px solid ${colors.DARK_BLUE};
  }
`;

const whiteButtonStyles = css`
  background-color: #f4f6f6;
  color: rgba(119, 139, 159, 1);

  &:hover {
    background-color: rgba(119, 139, 159, 0.7);
    color: #fff;
  }
`;

const ghostStyles = css`
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
`;

const Button = ({ children, size = 'standard', type = 'round', variant, onClick }) => (
  <StyledButton variant={variant} type={type} size={size} onClick={onClick}>
    {children && <span>{children}</span>}
  </StyledButton>
);

export default Button;
